
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index1S_45c4lFeJDlVZMg3JC6wtrIEtRTF4_45KKqdCUWX5FfWAMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/index.vue?macro=true";
import { default as _91id_93sGY1s_09FHU_4D7ILMn_f_JB9rk3k2Jn1ODaa9pvHkQMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/cupons/[id].vue?macro=true";
import { default as novoJEp0ma4FG3JLUxFMvgHUeAXQGAGLlfvxs_45qextQ39_45YMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/cupons/novo.vue?macro=true";
import { default as index_45yv9RQLFuqabzbFh5nxtGF2z9FODwLPpndZUgzt_45vbsMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/cupons/index.vue?macro=true";
import { default as indexaw_J2HqNHkOg9tyyASMTt7bSr6OElO__SAwT5zB_45gfEMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/pedidos/index.vue?macro=true";
import { default as index1FLZJZOPq41GnkjurlyznTRLwoXGq_Kg0K3E6ysk9scMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/auditoria/index.vue?macro=true";
import { default as indexvfa_45QyxlEv7b8okNGxVN8mKeV6IwvHPYJiszhnBElHkMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/logistica/index.vue?macro=true";
import { default as index3dNB1HSHEpZcjnoeOfQdHIuSBnvDeBBzJp2tWn_45diVEMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/orcamentos/index.vue?macro=true";
import { default as index_45J_KY_45LsMt41ySZhS5KRQ7jF6gLt8Yhmfz3_45Iz6JQOEMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/pedidos/[id]/index.vue?macro=true";
import { default as indexmLJfvd2Ak20Cx0vNlgH8f2b3p9S8NiNxAIeq0WGIPbUMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/planejamento/index.vue?macro=true";
import { default as indexvf46TELXPTE3Aii3yI_451NAilCtU4_45N3WKhrbet17c1IMeta } from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/precificacao/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/index.vue")
  },
  {
    name: "cupons-id",
    path: "/cupons/:id()",
    meta: {"middleware":["cupons"]},
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/cupons/[id].vue")
  },
  {
    name: "cupons-novo",
    path: "/cupons/novo",
    meta: {"middleware":["cupons"]},
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/cupons/novo.vue")
  },
  {
    name: "cupons",
    path: "/cupons",
    meta: {"middleware":["cupons"]},
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/cupons/index.vue")
  },
  {
    name: "pedidos",
    path: "/pedidos",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/pedidos/index.vue")
  },
  {
    name: "auditoria",
    path: "/auditoria",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/auditoria/index.vue")
  },
  {
    name: "logistica",
    path: "/logistica",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/logistica/index.vue")
  },
  {
    name: "orcamentos",
    path: "/orcamentos",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/orcamentos/index.vue")
  },
  {
    name: "pedidos-id",
    path: "/pedidos/:id()",
    meta: {"middleware":["pedidos"]},
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/pedidos/[id]/index.vue")
  },
  {
    name: "planejamento",
    path: "/planejamento",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/planejamento/index.vue")
  },
  {
    name: "precificacao",
    path: "/precificacao",
    component: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/pages/precificacao/index.vue")
  }
]